import { store, getContext } from "@wordpress/interactivity";

const { state } = store("filterable-comunicati", {
  state: {
    get filteredPosts() {
      const { posts, searchQuery } = state;
      const q = searchQuery.trim().toLowerCase();
      if (!q) return posts;
      return posts.filter((p) => p.titolo.toLowerCase().includes(q));
    },

    get visibleIds() {
      return new Set(
        state.filteredPosts.slice(0, state.visibleCount).map((p) => p.id),
      );
    },

    get getItemDisplay() {
      const { postId } = getContext();
      return state.visibleIds.has(postId) ? "block" : "none";
    },

    get emptyDisplay() {
      return state.filteredPosts.length === 0 ? "block" : "none";
    },

    get loadMoreDisplay() {
      return state.filteredPosts.length > state.visibleCount ? "flex" : "none";
    },
  },

  actions: {
    setSearch(event) {
      state.searchQuery = event.target.value;
      state.visibleCount = state.perPage;
    },

    loadMore() {
      state.visibleCount += state.perPage;
    },
  },
});
